import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { environment } from '../../environments/environment';

export class BaseService {

    protected auth: Auth = inject(Auth);
    protected httpClient: HttpClient = inject(HttpClient);

    protected backendDomain = environment.backendUrl;

    protected appendQueryParam(queryParams: HttpParams, name: string, value: string | number | boolean | undefined) {
        if (value != undefined) {
            if (typeof value === "string") {
                if (value != null
                &&  value != "") {
                    queryParams = queryParams.append(name, value);
                }
            } else {
                queryParams = queryParams.append(name, value);
            }
        }

        return queryParams
    }

    protected getHeaders(idToken: string) {
        return new HttpHeaders({ "Content-Type": "application/json" }).append("Authorization", `Bearer ${idToken}`)
                                .append("X-AeroStar-Svc-Requestor", "AeroStar-Web-Frontend");
    }
}
